const Twig = require('twig');

const twigApply = require('../libs/twig/apply');
const twigFlush = require('../libs/twig/flush');
const twigMarkdown = require('../libs/twig/md');
const twigFormatNumber = require('../libs/twig/format_number');
const twigFormatItemcount = require('../libs/twig/format_itemcount');
const twigFormatCurrency = require('../libs/twig/format_currency');
const twigCarddata = require('../libs/twig/carddata');
const twigAlphasortOptions = require('../libs/twig/alphasort_options');
const twigProminentsortOptions = require('../libs/twig/prominentsort_options');

Twig.extend(twigApply);
Twig.extend(twigFlush);
Twig.extendFilter('md', twigMarkdown);
Twig.extendFilter('replace', (value, params) => {
  if (value === undefined || value === null) {
    return;
  }

  const pairs = params[0];
  let tag;
  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (tag in pairs) {
    try {
      if (Object.hasOwnProperty.call(pairs, tag) && tag !== '_keys') {
        value = value.split(tag).join(pairs[tag]);
      }
    } catch (e) {
      console.log(value, params);
    }
  }

  // eslint-disable-next-line consistent-return
  return value;
});
Twig.extendFilter('format_number', twigFormatNumber);
Twig.extendFilter('format_itemcount', twigFormatItemcount);
Twig.extendFilter('format_currency', twigFormatCurrency);
Twig.extendFilter('carddata', twigCarddata);
Twig.extendFilter('alphasort_options', twigAlphasortOptions);
Twig.extendFilter('prominentsort_options', twigProminentsortOptions);
Twig.cache(true);

module.exports = Twig;



// WEBPACK FOOTER //
// ./src/_utilities/twig-init.js